export { errorLink } from './graphQLError'
